import { z } from 'zod';

export const SEmergencyContactResponse = z.object({
  id: z.number(),
  contact_body_address: z.string().nullable(),
  name: z.string().nullable(),
  phone_number: z.string().nullable(),
  relation: z.number().nullable(),
  blood_type: z.number().nullable(),
  rhesus_type: z.number().nullable(),
  emergency_note: z.string().nullable(),
  is_active: z.boolean(),
});
export type TEmergencyContactResponse = z.infer<
  typeof SEmergencyContactResponse
>;
